import { CheckboxGroup } from '@global-engineering-shared/gweb-material-global';
import React from 'react';

import CheckboxToggle from 'components/CheckboxToggle';
import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import useStyles from 'components/CheckboxToggleGroup/CheckboxToggleGroup.styles';

type CheckboxToggleGroupProps = {
  toggles: Toggle[];
  setToggles: React.Dispatch<React.SetStateAction<Toggle[]>>;
};

const CheckboxToggleGroup = ({ toggles, setToggles }: CheckboxToggleGroupProps) => {
  const classes = useStyles();

  return (
    <CheckboxGroup row className={classes.root}>
      {toggles.map((child, index) => (
        <CheckboxToggle key={index} toggle={child} setToggles={setToggles} />
      ))}
    </CheckboxGroup>
  );
};

export default CheckboxToggleGroup;
